import React from 'react';

const StepContext = React.createContext({
  triggerSubmit: () => {},
  onSubmit: () => {},
  step: null,
  stepFormName: null,
});

export default StepContext;
